// ** React Imports
import React from 'react'

// ** MUI Imports
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

export const formatMoney = (value, currency, digits = 2) => {
  if (value === null || value === undefined) return '—'
  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency,
      minimumFractionDigits: digits,
      maximumFractionDigits: Math.max(digits, value !== 0 && Math.abs(value) < 0.01 ? 6 : digits)
    }).format(value)
  } catch (e) {
    return `${value} ${currency}`
  }
}

// ** Rounded to 2 decimals, without decimals when the value is a whole number
export const formatPrice = (value, currency) => {
  if (value === null || value === undefined) return '—'
  const rounded = Math.round(value * 100) / 100
  const digits = Number.isInteger(rounded) ? 0 : 2
  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(rounded)
  } catch (e) {
    return `${rounded} ${currency}`
  }
}

export const periodLabel = cycle => {
  if (!cycle?.periodType) return ''
  const unit = { MONTH: 'mo', YEAR: 'yr', DAY: 'day' }[cycle.periodType] || cycle.periodType.toLowerCase()
  return cycle.duration && cycle.duration > 1 ? `/${cycle.duration} ${unit}` : `/${unit}`
}

export const PLAN_COLORS = {
  FLEXIBLE: 'info',
  COMMITMENT: 'primary',
  TRIAL: 'default',
  FREE: 'default'
}

const STATUS = {
  match: { label: 'Match', color: 'success' },
  mismatch: { label: 'Mismatch', color: 'error' },
  missing: { label: 'Missing price', color: 'warning' },
  not_in_app: { label: 'Not in app', color: 'default' }
}

export const StatusChip = ({ app, currency }) => {
  if (!app || !STATUS[app.status]) return null
  const { label, color } = STATUS[app.status]
  let title = app.reason || ''
  if (app.status === 'mismatch' && app.diff !== undefined) {
    const sign = app.diff > 0 ? '+' : ''
    title = `App ${formatMoney(app.price, currency)} vs Google ${formatMoney(app.googleMonthly ?? null, currency)} (${sign}${
      app.diff
    }${app.diffPct !== null && app.diffPct !== undefined ? `, ${sign}${app.diffPct}%` : ''})`
  }
  const chip = <Chip size='small' variant='outlined' color={color} label={label} sx={{ height: 20, fontSize: 11 }} />
  return title ? <Tooltip title={title}>{chip}</Tooltip> : chip
}

export const SummaryChips = ({ totals, onSelect, selected }) => {
  if (!totals) return null
  return (
    <>
      {Object.keys(STATUS).map(key => (
        <Chip
          key={key}
          size='small'
          color={STATUS[key].color}
          variant={selected === key ? 'filled' : 'outlined'}
          label={`${STATUS[key].label}: ${totals[key] || 0}`}
          onClick={onSelect ? () => onSelect(selected === key ? null : key) : undefined}
          sx={{ mr: 1, mb: 1 }}
        />
      ))}
    </>
  )
}
